import React from 'react';
import Timeline from 'Components/ComponentLibrary/Organisms/Timeline';
import ScenarioOutcomeTimelineCard
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedScenarioDetailsStepTemplate/Content/ScenarioOutcomeTimelineCard';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';

const ProposalProjectionSectionLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FadeInBox>
      <FDStack direction={'column'} alignItems={'center'} spacing={5}>
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'subtitle'} />
        <Timeline timelineYearGroupCollection={resource.attr('scenarioOutcomeTimelineYearGroups')} timelineCardComponent={ScenarioOutcomeTimelineCard} />
      </FDStack>
    </FadeInBox>
  );
};

ProposalProjectionSectionLayout.defaultProps = {};

ProposalProjectionSectionLayout.propTypes = {};

export default ProposalProjectionSectionLayout;
